/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Evgenij Tyan
 * @version 1.0.1
 * @since 1.0.1
 */

import IWidgetSubscriberMaxCostsTranslation from '../../../types/pages/dashboard/widgetSubscriberMaxCosts';

const initTranslationWidgetSubscriberMaxCosts: IWidgetSubscriberMaxCostsTranslation = {
    empty: {
        helpText: '',
        title: '',
    },
    fail: {
        text: '',
    },
    hasFixed: '',
    successful: {
        btnText: '',
    },
    title: '',

};

export default initTranslationWidgetSubscriberMaxCosts;
